// Upload
export const SET_MEDIAS_LOADING = 'SET_MEDIAS_LOADING';
export const SET_MEDIAS = 'SET_MEDIAS';
export const SET_MEDIAS_ERROR = 'SET_MEDIAS_ERROR';
export const SET_MEDIA_ERROR = 'SET_MEDIA_ERROR';
export const SET_UPLOADED_MEDIAS = 'SET_UPLOADED_MEDIAS';
export const SET_MEDIA_PREVIEW = 'SET_MEDIA_PREVIEW';
export const SET_MEDIA_UPDATE = 'SET_MEDIA_UPDATE';
export const SET_MEDIA_LOADING = 'SET_MEDIA_LOADING';
export const SET_MEDIA_UPLOAD = 'SET_MEDIA_UPLOAD';
export const SET_MEDIA_NAME_INVALID = 'SET_MEDIA_NAME_INVALID';

export const ADD_MEDIA_LABEL_SUGGESTION = 'ADD_MEDIA_LABEL_SUGGESTION';
export const REMOVE_MEDIA_LABEL_SUGGESTION = 'REMOVE_MEDIA_LABEL_SUGGESTION';
export const SET_MEDIA_LIST = 'SET_MEDIA_LIST';
